// @flow
import * as React from 'react';
import { RequiredActionProps } from '../../types';
import { ButtonBase, Stack, Typography } from '@mui/material';
import moment from 'moment/moment';
import { ArrowsLeftRightIcon, XIcon } from '@phosphor-icons/react';
import {
  AgentView, Portal, useAgentByIdQuery, useAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation,
  UserAvatar
} from '../../../../shared';
import { useMemo } from 'react';
import { LoadingButton } from '@mui/lab';

export const ArCsrAcknowledgedAgentWillBeLateRequiredAction = ({item, onResolved, onHide}: RequiredActionProps) => {
  const details = useMemo(() => JSON.parse(item.detailsJson), [item.detailsJson]);
  const [processed] = useAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentMutation({
    variables: {id: item.id},
  })

  const {data} = useAgentByIdQuery({
    variables: {
      id: details.agentId,
    },
    skip: !details.agentId
  });
  const agent = data?.agentById;

  const complete = async () => {
    await processed();
    onResolved();
  }

  return (
    <Portal sx={{'&:hover': {border: '1px solid #d0d5e1' }, transition: 'all .3s', mb: 2, background: '#FFF', minWidth: 366 }}>
      <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}
             sx={{background: 'linear-gradient(137deg, rgba(247, 231, 186, 1) 0%, rgb(231 253 255) 70%)'}} p={'8px 12px'}>
        <Typography flex={1} variant={'h5'} fontWeight={500} noWrap>
          CSR responded
        </Typography>

        <Typography variant={'caption'} align={'right'}>
          {moment(item.createdAt).format('L H:mm')}
        </Typography>

        {onHide && <ButtonBase onClick={onHide}>
          <XIcon size={16} color={'#1c434f'} weight={'bold'} />
        </ButtonBase>}
      </Stack>

      <Typography flex={1} p={1} variant={'body2'}>
        The CSR responded that you would be late on appointment.<br/>
        <Typography variant={'caption'} color={'text.secondary'}>Appointment scheduled for: <b>{moment(details.startTime).format('L H:mm')}</b></Typography>
      </Typography>

      <Stack gap={1} direction={'row'} alignItems={'center'} pr={1}>
        <ButtonBase onClick={() => window.open(`/${'client'}/${details.invitee?.clientId}`, '_blank')}
                    sx={{
                      padding: '4px 8px',
                      borderRadius: '8px'
                    }}
        >
          <UserAvatar size={32}
                      fontSize={13}
                      showEmail
                      email={details.invitee?.email}
                      name={details.invitee?.name} />
        </ButtonBase>

        <ArrowsLeftRightIcon size={32} color={'#70a6b6'} weight={'bold'} />

        <AgentView agent={agent} />
      </Stack>

      <Stack p={1} justifyContent={'flex-end'} gap={1} direction={'row'}>
        <LoadingButton sx={{width: 100}} size={'small'} variant={'contained'} onClick={complete}>
          Close
        </LoadingButton>
      </Stack>
    </Portal>
  );
};
